import { locationChanged } from '../../../actions/one-app';
import { ONE_APP_MODALS } from '../constants';

export default function onHideModal({ action }) {
  return dispatch => {
    const { type } = action.payload;
    if (ONE_APP_MODALS.indexOf(type) === -1) {
      return;
    }

    dispatch(locationChanged({ action: 'dismissModal' }));
  };
}
